import React, { useContext, useState } from "react";

import ActionPermissionGuard from "shared/components/utils/ActionPermissionGuard";
import AngleCirculeRight from "shared/components/utils/icons/AngleCirculeRight";
import Checkbox from "shared/components/inputs/checkbox/Checkbox";
import Context from "features/allocations/contexts/Context";
import CustomGroupContext from "features/allocations/contexts/CustomGroupContext";
import DownArrow from "shared/components/utils/icons/DownArrow";
import EmployeeContext from "features/allocations/contexts/EmployeeContext";
import EmployeeDrawer from "./EmployeeDrawer";
import EmployeeGridSelectionContext from "features/allocations/contexts/EmployeeGridSelectionContext";
import GenericSidebarPortal from "shared/components/feedback/modals/common/GenericSidebarPortal";
import More from "./More";
import Pills from "./Pills";
import PropTypes from "prop-types";
import getEmployeeKey from "./utils/getEmployeeKey";
import {
    MoreMenuContainer,
    Wrapper,
    IndentColumn,
    Column,
    WrapperEmployee,
    WrapperAction,
    StyledEmployeeProfile,
} from "./EmployeeHeader.styles";

const EmployeeHeader = React.memo(
    ({ expanded, initialData }) => {
        const { employeeData } = useContext(EmployeeContext);
        const customGroupConsumer = useContext(CustomGroupContext);
        const contextConsumer = useContext(Context);
        const employeeGridSelection = useContext(EmployeeGridSelectionContext);
        const [drawerUserId, setDrawerUserId] = useState();

        const handleDrawerClose = () => {
            setDrawerUserId(null);
        };

        const handleClick = (userId) => {
            if (userId > 0) {
                if (drawerUserId == null) {
                    setDrawerUserId(userId);
                } else {
                    setDrawerUserId(null);
                }
            }
        };

        let employeeInfo = employeeData?.name ? employeeData : initialData;
        const realEmployee = employeeInfo.userId && employeeInfo.userId !== "0";

        const isSelectable =
            employeeGridSelection.allSelectableEmployeeIDs.includes(
                employeeInfo.userId
            );

        const isSelected = employeeGridSelection.selectedEmployeeIDs.includes(
            employeeInfo.userId
        );


        const tooltip1 = isSelected ? "Deselect Employee" : "Select Employee";
        const tooltip2 = realEmployee ? "Cannot Select Employee" : "Cannot Select TBDs";
        const tooltip = isSelectable ? tooltip1 : tooltip2;

        const handleOnClickRowCheckbox = (e) => { e.target.checked ? employeeGridSelection.addIdToSelection(employeeInfo.userId) : employeeGridSelection.removeIdFromSelection(employeeInfo.userId); };

        const fadeRow = (row) => {
            let opacity = 1;
            let interval = setInterval(function () {
                if (opacity > 0) {
                    opacity -= 0.1;
                    row.firstChild.style.backgroundColor = "rgba(128, 128, 128," + opacity + ")";
                } else {
                    row.firstChild.style.backgroundColor = "white";
                    clearInterval(interval);
                }
            }, 10);
        }

        const handleDetailClick = (id) => {
            const expandedRow = document.getElementById("div_" + id);
            fadeRow(expandedRow);
            const divEmployee = document.getElementById("div_detail_" + getEmployeeKey(initialData));
            const divIco1 = document.getElementById("btn_ico1" + getEmployeeKey(initialData));
            const divIco2 = document.getElementById("btn_ico2" + getEmployeeKey(initialData));
            const divEmpHeader = document.getElementById("emp_header_wrapper_" + getEmployeeKey(initialData))
            if (divEmployee) {
                if (divEmployee.style.display === "none") {
                    divEmployee.style.display = "";
                    if (divIco1 && divIco2) {
                        divIco1.style.display = "";
                        divIco2.style.display = "none";
                    }
                } else {
                    divEmployee.style.display = "none";
                    divEmpHeader.classList.remove("allocationsStickyEmployee");
                    divEmpHeader.style.top = 0;
                    globalThis.stickyHeader();
                    if (divIco1 && divIco2) {
                        divIco1.style.display = "none";
                        divIco2.style.display = "";
                    }
                }
            }
        }

        return (
            <>
                {employeeInfo?.fullName && (
                    <Wrapper id={"emp_header_wrapper_" + getEmployeeKey(employeeInfo)} className="allocEmpHeader" >
                        <IndentColumn xs={1} />
                        <Column xs={4} lg={3}>
                            <WrapperEmployee>
                                <WrapperAction>
                                    {employeeGridSelection.selectionIsEnabled ? (
                                        <ActionPermissionGuard code="AC_SELECT_MULTIPLE_EMP">
                                            <Checkbox
                                                title={tooltip}
                                                isSmallSize={true}
                                                disabled={!isSelectable}
                                                checked={isSelected}
                                                onClick={handleOnClickRowCheckbox}
                                            />
                                        </ActionPermissionGuard>
                                    ) : (
                                        <>
                                            <button
                                                id={"btn_ico1" + getEmployeeKey(employeeInfo)}
                                                type="button"
                                                onClick={() => { handleDetailClick(getEmployeeKey(employeeInfo)); }}
                                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                            >
                                                <DownArrow />
                                            </button>

                                            <button
                                                id={"btn_ico2" + getEmployeeKey(employeeInfo)}
                                                type="button"
                                                style={{ display: "none", background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                                onClick={() => { handleDetailClick(getEmployeeKey(employeeInfo)); }}
                                            >
                                                <AngleCirculeRight />
                                            </button>
                                        </>
                                    )}
                                </WrapperAction>
                                <StyledEmployeeProfile
                                    key={employeeInfo.userId}
                                    id={employeeInfo.userId}
                                    index={employeeInfo.userId}
                                    name={employeeInfo.fullName}
                                    title={employeeInfo.title}
                                    location={employeeInfo.office}
                                    image={employeeInfo.smallPhoto || undefined}
                                    departureDate={employeeInfo.departureDate}
                                    employeeStatus={employeeInfo.employeeStatus}
                                    onClick={realEmployee ? () => handleClick(employeeInfo.userId) : void 0}
                                />
                                <MoreMenuContainer>
                                    {realEmployee ? (<More employee={employeeInfo} />) : null}
                                </MoreMenuContainer>
                            </WrapperEmployee>
                        </Column>
                        <Pills
                            initialData={employeeInfo}
                        />
                        <IndentColumn xs={1} />
                    </Wrapper>
                )}
                {drawerUserId && (
                    <Context.Provider value={contextConsumer}>
                        <CustomGroupContext.Provider value={customGroupConsumer}>
                            <GenericSidebarPortal
                                open={true}
                                content={<EmployeeDrawer userId={drawerUserId} />}
                                onClose={handleDrawerClose}
                            />
                        </CustomGroupContext.Provider>
                    </Context.Provider>
                )}
            </>
        );
    }
);

EmployeeHeader.propTypes = {
    initialData: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
};

export default EmployeeHeader;
